<template>
  <div class="meiyu">
    <div class="top">
      <div class="topdate">{{ date }}</div>
      <span class="title">永嘉山洪灾害监测预警</span>
      <div class="full" @click="buttonfull">
        <svg v-if="watchfull" class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconsuoxiaoquanping"></use>
        </svg>
        <svg v-else class="icon" aria-hidden="true" style="color: #00dcfc;">
          <use xlink:href="#iconquanping"></use>
        </svg>
      </div>
      <!-- <div class="back" @click="back" v-show="backitem">
        <img src="@/assets/meiyu/back.png" alt="" />
        <span class="backdesc">首页</span>
      </div> -->
    </div>
    <div v-loading="loading" id="centermap" class="homepage-map"></div>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col v-for="(item, index) in yj" :key="index" :span="4">
        <div class="grid-content bg-purple">
          <el-tooltip placement="bottom">
            <div slot="content" v-if="item.name === '预警村落'" class="warnItems">
              <div v-for="(item, index) in villageOver" :key="index" v-html="villageOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '水库超汛限'" class="warnItems">
              <div v-for="(item, index) in reservoirOver" :key="index" v-html="reservoirOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '河道水位超警'" class="warnItems">
              <div v-for="(item, index) in riverOver" :key="index" v-html="riverOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '雨量1h>30'" class="warnItems">
              <div v-for="(item, index) in rain1hOver" :key="index" v-html="rain1hOver[index]"></div>
            </div>
            <div slot="content" v-if="item.name === '雨量3h>60'" class="warnItems">
              <div v-for="(item, index) in rain3hOver" :key="index" v-html="rain3hOver[index]"></div>
            </div>
             <div slot="content" v-if="item.name === '雨量6h>80'" class="warnItems">
              <div v-for="(item, index) in rain6hOver" :key="index" v-html="rain6hOver[index]"></div>
            </div>
            <div>
              <p class="warn-name"><img v-if="item.iconUrl !== undefined" :src="item.iconUrl" width="18px" height="18px" style="margin-right:10px" />{{ item.name }}</p>
              <p class="warn-num">
                <b>{{ item.num }}</b
                ><span>个</span>
              </p>
            </div>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
    <div class="left">
      <div v-show="picControl" class="leftNavs">
        <div class="navTitle">
          图层控制<i
            @click="
              picControl = false
              picicon = true
            "
            class="el-icon-close"
            style="cursor:pointer;font-size: .6rem;float: right;margin: 10px 10px 0;"
          ></i>
        </div>
        <div class="navMain">
          <div class="navli" v-for="(item, index) in navli" :key="index" v-show="item.isShow">
            <img :src="item.img" />
            <div class="navtext">{{ item.name }}</div>
            <div>
              <el-switch v-model="item.select" size="mini" @change="(val) => switchChange(item, val)"></el-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="realtimerain">
        <div class="contain">
          <div class="title">
            <div class="titlename">
              <div class="titlename_up">
                <span class="ssyq">实时雨情</span>
                <div class="selected_time">
                  <span class="time_item" :class="{ item_active: index == choosed }" v-for="(item, index) in selectedTime" :key="index" @click="checkItem(item, index)">
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="barcharts" v-loading="loading1" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div class="qqmyl">
              <span class="allrain" @click="openAllrainDialog">全县面雨量</span>
              <span class="val">{{ allrain }}<span class="danwei">mm</span></span>
            </div>
            <div id="rainchart"></div>
          </div>
        </div>
      </div>
      <div class="realtimewater" ref="realtimewater">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">单站</span>
                <div class="searchsta">
                  <el-input @change="rainChange" size="small" placeholder="请输入测站名称" v-model="staname" clearable>
                    <i @click="rainChange" slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="content singleStationContent" ref="singleStationContent">
            <el-table
              ref="rainable"
              @cell-mouse-enter="handleMouseEnter"
              @cell-mouse-leave="handleMouseOut"
              v-loading="loading1"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              :data="statable"
              :height="tableheight"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName"
              @row-click="handleRowClick"
            >
              <el-table-column prop="name" label="站点名称" min-width="90">
                <template  slot-scope="scope">
                  <!-- <el-tooltip  effect="light" :content="scope.row.name" placement="top" popper-class="hiddenOverflow">
                    <span style="cursor:pointer"> {{ scope.row.name? scope.row.name : '- -' }}</span>
                  </el-tooltip> -->
                  <div>
                    <div style="cursor:pointer">
                      <i v-if="scope.row.value > 0" style="color: #fff;font-size:18px" class="el-icon-light-rain"></i>
                      {{ scope.row.name? scope.row.name : '- -' }}
                    </div>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="addvnm" label="所属乡镇" min-width="60"> </el-table-column>
              <el-table-column align="center" prop="value" label="雨量" min-width="60" sortable> </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="realtimewater rightrealtimewater" ref="realtimewater">
        <div class="contain">
          <div class="title raintitle">
            <div class="titlename">
              <div class="titlename_up">
                <span class="sssq">实时水情</span>
                <div class="searchsta stawater">
                  <el-input @change="togglewater" size="small" placeholder="请输入测站名称" v-model="waterstaname" clearable>
                    <i @click="togglewater" slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
                <div class="selected_time" style="width: auto;position: absolute;right: 0;">
                  <span class="time_item" :class="{ item_active: index == choosed1 }" v-for="(item, index) in selectedReservoirRiver" :key="index" @click="checkItem1(item, index)">
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
              <img src="@/assets/meiyu/titlebottom.png" alt="" />
            </div>
          </div>
          <div class="content" ref="realtimewaterContent">
            <!-- 河道 -->
            <!-- 超警 -->
            <el-table class="overtable"
              :data="overriverData"
              v-show="this.choosed1 === 1"
              stripe max-height="500"
              style="width:100%;"
              :row-class-name="tableRowClassName"
              @row-click="handleRowClick"
              @cell-mouse-enter="handleOverMouseEnter"
              @cell-mouse-leave="handleOverMouseOut"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="80">
                <template slot-scope="scope">
                   <!-- <el-tooltip  effect="light" :content="scope.row.stcd" placement="top" popper-class="hiddenOverflow">
                    <span style="cursor:pointer"> {{ scope.row.stnm ? scope.row.stnm : '- -' }}</span>
                  </el-tooltip> -->
                  <div>
                    <div style="cursor:pointer"> {{ scope.row.stationName? scope.row.stationName : '- -' }}</div>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stnm + ' ' + scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="65">
                <template slot-scope="scope">
                  <span>{{ scope.row.water_Str ? scope.row.water_Str : '- -' }}</span>
                  <i v-if="scope.row.diffLastHourWater>0" style="color: #e02020;font-size:18px" class="el-icon-top"></i>
                  <i v-else-if="scope.row.diffLastHourWater<0" style="color: #6dd400;font-size:18px" class="el-icon-bottom"></i>
                  <i v-else-if="scope.row.diffLastHourWater===0" style="color: #fff;font-size:18px" class="el-icon-right"></i>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超警戒" min-width="70" sortable :sort-method="sortMethod1">
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowGuaranteeWater_Str" label="超保证" min-width="70" sortable :sort-method="sortMethod2">
                <template slot-scope="scope">
                  {{ scope.row.overflowGuaranteeWater_Str ? scope.row.overflowGuaranteeWater_Str : '- -' }}
                </template>
              </el-table-column>
              <div slot="empty"></div>
            </el-table>
            <!-- 未超警 -->
            <el-table
              ref="commontable"
              :data="commonriverData"
              @cell-mouse-enter="handleMouseEnter"
              @cell-mouse-leave="handleMouseOut"
              v-show="this.choosed1 === 1"
              :height="commontableh"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName"
              :show-header="hiddenTableHeader"
              @row-click="handleRowClick"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="90">
                <template slot-scope="scope">
                  <!-- {{ scope.row.stnm ? scope.row.stnm : '- -' }} -->
                  <!-- <el-tooltip  effect="light" :content="scope.row.stcd" placement="top" popper-class="hiddenOverflow"> -->
                    <!-- <span style="cursor:pointer"> {{ scope.row.stnm ? scope.row.stnm : '- -' }}</span> -->
                  <!-- </el-tooltip> -->
                   <div>
                    <div style="cursor:pointer"> {{ scope.row.stationName? scope.row.stationName : '- -' }}</div>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stnm + ' ' + scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="65">
                <!-- <template slot-scope="scope">
                  {{ scope.row.water_Str ? scope.row.water_Str : '- -' }}
                </template> -->
                <template slot-scope="scope">
                  <span>{{ scope.row.water_Str ? scope.row.water_Str : '- -' }}</span>
                  <i v-if="scope.row.diffLastHourWater>0" style="color: #e02020;font-size:18px" class="el-icon-top"></i>
                  <i v-else-if="scope.row.diffLastHourWater<0" style="color: #6dd400;font-size:18px" class="el-icon-bottom"></i>
                  <i v-else-if="scope.row.diffLastHourWater===0" style="color: #fff;font-size:18px" class="el-icon-right"></i>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超警戒" min-width="65" sortable :sort-method="sortMethod1">
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowGuaranteeWater_Str" label="超保证" min-width="70" sortable :sort-method="sortMethod2">
                <template slot-scope="scope">
                  {{ scope.row.overflowGuaranteeWater_Str ? scope.row.overflowGuaranteeWater_Str : '- -' }}
                </template>
              </el-table-column>
            </el-table>
            <!-- 水库 -->
            <!-- 超汛限 -->
            <el-table
              class="overrestable"
              :data="overresData"
              max-height="500"
              v-show="this.choosed1 === 0"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName1"
              @row-click="handleRowClick"
              @cell-mouse-enter="handleOverMouseEnter"
              @cell-mouse-leave="handleOverMouseOut"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="75">
                <template slot-scope="scope">
                   <!-- <div>
                    <el-tooltip  effect="light" content="scope.row.stcd" placement="top" popper-class="hiddenOverflow">
                      <span style="cursor:pointer"> {{ scope.row.stnm ? scope.row.stnm : '- -' }}</span>
                    </el-tooltip>
                   </div> -->
                  <div>
                    <div style="cursor:pointer"> <span></span>{{ scope.row.stationName? scope.row.stationName : '- -' }}</div>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stnm + ' ' + scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="65">
                <template slot-scope="scope">
                  <span>{{ scope.row.water_Str ? scope.row.water_Str : '- -' }}</span>
                  <i v-if="scope.row.diffLastHourWater>0" style="color: #e02020;font-size:18px" class="el-icon-top"></i>
                  <i v-else-if="scope.row.diffLastHourWater<0" style="color: #6dd400;font-size:18px" class="el-icon-bottom"></i>
                  <i v-else-if="scope.row.diffLastHourWater===0" style="color: #fff;font-size:18px" class="el-icon-right"></i>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="warningWater_Str" label="汛限水位" min-width="61">
                <template slot-scope="scope">
                  {{ scope.row.warningWater_Str ? scope.row.warningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超汛限" min-width="51" sortable>
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <div slot="empty"></div>
            </el-table>
            <!-- 未超汛 -->
            <el-table
              ref="commonrestable"
              :height="commonrestableh"
              :show-header="hiddenTableHeader"
              @cell-mouse-enter="handleMouseEnter"
              @cell-mouse-leave="handleMouseOut"
              :data="commonresData"
              v-show="this.choosed1 === 0"
              stripe
              style="width:100%;"
              :row-class-name="tableRowClassName1"
              @row-click="handleRowClick"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            >
              <el-table-column prop="stnm" label="站点名称" min-width="75">
                <template slot-scope="scope">
                   <!-- <el-tooltip  effect="light" :content="scope.row.stcd" placement="top" popper-class="hiddenOverflow"> -->
                      <!-- <span style="cursor:pointer"> {{ scope.row.stnm ? scope.row.stnm : '- -' }}</span> -->
                  <!-- </el-tooltip> -->
                  <div>
                    <div style="cursor:pointer"> {{ scope.row.stationName? scope.row.stationName : '- -' }}</div>
                    <div class="showTool" v-show="hoverCurrentStcd === scope.row.stcd ">{{(scope.row.stnm + ' ' + scope.row.stcd)}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="water_Str" label="水位" min-width="65">
                <template slot-scope="scope">
                  <span>{{ scope.row.water_Str ? scope.row.water_Str : '- -' }}</span>
                  <i v-if="scope.row.diffLastHourWater>0" style="color: #e02020;font-size:18px" class="el-icon-top"></i>
                  <i v-else-if="scope.row.diffLastHourWater<0" style="color: #6dd400;font-size:18px" class="el-icon-bottom"></i>
                  <i v-else-if="scope.row.diffLastHourWater===0" style="color: #fff;font-size:18px" class="el-icon-right"></i>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="warningWater_Str" label="汛限水位" min-width="61">
                <template slot-scope="scope">
                  {{ scope.row.warningWater_Str ? scope.row.warningWater_Str : '- -' }}
                </template>
              </el-table-column>
              <el-table-column align="center" prop="overflowWarningWater_Str" label="超汛限" min-width="51" sortable>
                <template slot-scope="scope">
                  {{ scope.row.overflowWarningWater_Str ? scope.row.overflowWarningWater_Str : '- -' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="全县面雨量" width="60%" id="chartall" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time">
              <span class="time_item" :class="{ item_active: index == choosed2 }" v-for="(item, index) in selectedTimeDialog" :key="index" @click="checkItem2(item, index)">
                <span>{{ item.name }}</span>
              </span>
            </div>
          </div>
          <img src="@/assets/meiyu/titlebottom.png" alt="" />
        </div>
      </div>
      <div ref="rainchartAll" class="rainchartAll"
        v-loading="dialogLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"></div>
    </el-dialog>
    <div v-show="picicon" class="showBtn flexC" @click="showcontral"><i class="el-icon-open" style="font-size:1rem;"></i></div>
    <el-dialog title="时间选择" :visible.sync="choset" id="choset" :close-on-click-modal="false">
      <div class="title">
        <div class="titlename">
          <div class="titlename_up">
            <div class="selected_time" style="margin-left:30px;">
              <el-date-picker v-model="datev" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
            </div>
          </div>
        </div>
        <div style="width:100%;text-align:center;margin-top:30px;">
          <span slot="footer" class="dialog-footer">
            <el-button @click="choset = false">取 消</el-button>
            <el-button
              type="primary"
              @click="
                meiyu()
                choset = false
              "
              >确 定</el-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
    <div class="markerPopup" ref="markerPopup" v-show="markerPopup">
      <div class="popupTop">{{ wxqPointData[pointIndex].adnm }}</div>
      <div class="popupnav">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="1" v-if="wxqPointData[pointIndex].lng">
            <div class="jbxxInfo">
              <div class="jbxxText">
                <div>所属乡镇：</div>
                <div>{{ wxqPointData[pointIndex].townName }}</div>
              </div>
              <div class="jbxxText">
                <div>所属行政村：</div>
                <div>{{ wxqPointData[pointIndex].villageName }}</div>
              </div>
              <div class="jbxxText">
                <div>危险等级：</div>
                <div v-if="wxqPointData[pointIndex].danger">{{ wxqPointData[pointIndex].danger.dangerLevelName ? wxqPointData[pointIndex].danger.dangerLevelName : '/' }}</div>
              </div>
              <div class="jbxxText">
                <div></div>
                <div></div>
              </div>
            </div>
            <div class="jbxxLink">
              <!-- <div class="jbxxText"><div>村级防汛负责人：</div><div v-if="wxqPointData[pointIndex].majorPerson">{{wxqPointData[pointIndex].majorPerson.name}} {{wxqPointData[pointIndex].majorPerson.phone}}</div></div>
              <div class="jbxxText"><div>人员转移负责人：</div><div v-if="wxqPointData[pointIndex].transferPerson">{{wxqPointData[pointIndex].transferPerson.name}} {{wxqPointData[pointIndex].transferPerson.phone}}</div></div>
              <div class="jbxxText"><div>监测预警负责人：</div><div v-if="wxqPointData[pointIndex].monitorPerson">{{wxqPointData[pointIndex].monitorPerson.name}} {{wxqPointData[pointIndex].monitorPerson.phone}}</div></div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane label="危险区" name="2" v-if="navli[4].select">
            <div class="wxqInfo" v-if="wxqPointData[pointIndex].danger">
              <div class="flexDiv wxqText">
                <div class="title">极高危险区</div>
                <div class="flexDiv info">
                  <div>人口: {{ wxqPointData[pointIndex].danger.populationEHigh }}</div>
                  <div>房屋: {{ wxqPointData[pointIndex].danger.houseEHigh }}</div>
                </div>
              </div>
              <div class="flexDiv wxqText">
                <div class="title">高危险区</div>
                <div class="flexDiv info">
                  <div>人口: {{ wxqPointData[pointIndex].danger.populationHigh }}</div>
                  <div>房屋: {{ wxqPointData[pointIndex].danger.houseHigh }}</div>
                </div>
              </div>
              <div class="flexDiv wxqText">
                <div class="title">危险区</div>
                <div class="flexDiv info">
                  <div>人口: {{ wxqPointData[pointIndex].danger.population }}</div>
                  <div>房屋: {{ wxqPointData[pointIndex].danger.house }}</div>
                </div>
              </div>
            </div>
            <div class="wxqInfo" v-else>
              <div class="flexDiv wxqText">
                <div class="title">极高危险区</div>
                <div class="flexDiv info">
                  <div>人口: 0</div>
                  <div>房屋: 0</div>
                </div>
              </div>
              <div class="flexDiv wxqText">
                <div class="title">高危险区</div>
                <div class="flexDiv info">
                  <div>人口: 0</div>
                  <div>房屋: 0</div>
                </div>
              </div>
              <div class="flexDiv wxqText">
                <div class="title">危险区</div>
                <div class="flexDiv info">
                  <div>人口: 0</div>
                  <div>房屋: 0</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="预警指标" name="3">
            <div class="yjInfo">
              <el-table :data="yjzbData" style="width: 100%" :height="popupTableH">
                <el-table-column prop="stnm" label="站名" align="center">
                </el-table-column>
                <el-table-column prop="warnHours" label="时段(h)" align="center">
                </el-table-column>
                <el-table-column prop="warnDRP" label="准备转移预警指标" align="center">
                </el-table-column>
                <el-table-column prop="moveDRP" label="立即转移预警指标" align="center">
                </el-table-column>
                <el-table-column prop="promptDRP" label="临界雨量" align="center">
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="预警人员" name="4">
            <div class="yjInfo">
              <el-table :data="yjryData" style="width: 100%" :height="popupTableH">
                <el-table-column prop="personName" label="姓名" align="center" width="80"></el-table-column>
                <el-table-column prop="personPhone" label="手机" align="center"></el-table-column>
                <el-table-column prop="personPosition" label="岗位" align="center"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="stMarkerPopup" ref="stMarkerPopup" v-show="stMarkerPopup">
      <div class="popupTop">{{ stPointData[stpointIndex].poolName }}</div>
      <div class="popupnav">
        <el-tabs v-model="stActiveName" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="1">
            <div class="stInfo">
              <div class="stText">
                <div>山塘类别：</div>
                <div>{{ stPointData[stpointIndex].type }}</div>
              </div>
              <div class="stText">
                <div>所在位置：</div>
                <div>{{ stPointData[stpointIndex].adcdName }}</div>
              </div>
              <div class="stText">
                <div>是否整治：</div>
                <div>{{ stPointData[stpointIndex].isManaging ? '是' : '否' }}</div>
              </div>
              <div class="stText">
                <div>整治时间：</div>
                <div>{{ stPointData[stpointIndex].managedTime ? stPointData[stpointIndex].managedTime : '/' }}</div>
              </div>
              <div class="stText">
                <div>坝型：</div>
                <div>{{ stPointData[stpointIndex].damType }}</div>
              </div>
              <div class="stText">
                <div>坝顶高程(m)：</div>
                <div>{{ stPointData[stpointIndex].damHeight }}</div>
              </div>
              <div class="stText">
                <div>坝顶宽度(m)：</div>
                <div>{{ stPointData[stpointIndex].maxWidth }}</div>
              </div>
              <div class="stText">
                <div>坝顶长度(m)：</div>
                <div>{{ stPointData[stpointIndex].maxLength }}</div>
              </div>
              <div class="stText">
                <div>集雨面积(km²)：</div>
                <div>{{ stPointData[stpointIndex].rainArea }}</div>
              </div>
              <div class="stText">
                <div>正常蓄水位(m)：</div>
                <div>{{ stPointData[stpointIndex].water }}</div>
              </div>
              <div class="stText">
                <div>正常容积(万m³)：</div>
                <div>{{ stPointData[stpointIndex].storage }}</div>
              </div>
              <div class="stText">
                <div>设计频率(%)：</div>
                <div>{{ stPointData[stpointIndex].designedFreq }}</div>
              </div>
              <div class="stText">
                <div>设计洪水位(m)：</div>
                <div>{{ stPointData[stpointIndex].designedWater }}</div>
              </div>
              <div class="stText">
                <div>设计容积(万m³)：</div>
                <div>{{ stPointData[stpointIndex].designedStorage }}</div>
              </div>
              <div class="stText">
                <div>校核频率(%)：</div>
                <div>{{ stPointData[stpointIndex].checkFreq }}</div>
              </div>
              <div class="stText">
                <div>校核洪水位(m)：</div>
                <div>{{ stPointData[stpointIndex].checkWater }}</div>
              </div>
              <div class="stText">
                <div>校核容积(万m³)：</div>
                <div>{{ stPointData[stpointIndex].checkStorage }}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog class="timeChoose" title="时间选择" :visible.sync="timeChoose" :append-to-body="true" :modal="false" width="40%" :close-on-click-modal="false">
      <div class="dialog_wrapper">
        <div class="dialog_wrapper_top">
          <span class="top_inner_left">降雨时段</span>
          <span class="top_inner_right">
            <el-radio-group v-model="onTheHourRainTime" size="mini">
              <el-radio-button v-for="(item, index) in radioList2" :key="index" :label="item.label" @click.native="customTimeChange($event, item.label)">{{ item.name }}</el-radio-button>
            </el-radio-group>
          </span>
        </div>
        <div class="dialog_wrapper_bottom">
          <span class="bottom_inner_left">起止时间</span>
          <span class="bottom_inner_right">
            <el-date-picker v-model="BeginTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :picker-options="Global.pickerOptionsStart(EndTime)" placeholder="开始时间">
            </el-date-picker>
            <span style="color:#194F83;margin:0 5px 0 5px">——</span>
            <el-date-picker v-model="EndTime" type="datetime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :picker-options="Global.pickerOptionsEnd(BeginTime)" placeholder="结束时间">
            </el-date-picker>
          </span>
        </div>
        <div style="width:100%;text-align:center;margin-top:30px;">
          <span slot="footer" class="dialog-footer">
            <el-button @click="timeChoose = false">取 消</el-button>
            <el-button type="primary" @click="timeselect">确 定</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog :visible.sync="dialogVisible" width="60%">
      <div class="datebtn">
        <el-button @click="changedate(-1)" size="small">前一天</el-button>
        <span class="demonstration"></span>
        <el-date-picker
          v-model="datev"
          type="date"
          placeholder="选择日期"
          size="small"
          @change="changedate(0)">
        </el-date-picker>
        <el-button @click="changedate(1)" size="small">后一天</el-button>
      </div>
      <div id="station"></div>
    </el-dialog> -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="wxqPointData[pointIndex].pic.picUrl" />
    <!-- 测站弹窗 -->
    <stationDialog ref="stationDialog"></stationDialog>
    <!-- 预警村落信息 -->
    <el-dialog :title="yjcData.warnNM" :visible.sync="dialogYjc" class="yjdialog" :close-on-click-modal="false">
      <div class="info_content flexDiv">
        <div class="info_text flexDiv flexSB">
          <div>预警类型</div>
          <div>{{ yjcData.warnStatusNM }}</div>
        </div>
        <div class="info_text flexDiv flexSB">
          <div>时间</div>
          <div>{{ yjcData.warnTM }}</div>
        </div>
        <div class="info_desc flexDiv flexSB">
          <!-- <div>预警描述</div> -->
          <div>{{ yjcData.warnDesc }}</div>
        </div>
      </div>
    </el-dialog>
    <!-- 雨水情告知单导出生产弹框 -->
    <el-dialog title="雨水情告知单" :visible.sync="dialogWaterRainInfo" class="waterRainInfodialog" :close-on-click-modal="false" width="55%">
      <el-table
        v-loading="waterRainloading"
        :data="waterRainTableData"
        :max-height="waterRainHeight"
        stripe
        style="height:100%;width:100%"
      >
        <el-table-column type="index" align="center" header-align="center" label="序号" min-width="50">
        </el-table-column>
        <el-table-column align="center" header-align="center" prop="adnm" label="乡镇" min-width="120">
        </el-table-column>
        <el-table-column align="left" header-align="center" prop="warnDesc"  label="预警描述" :show-overflow-tooltip="true" min-width="300">
        </el-table-column>
        <el-table-column align="center" header-align="center" prop="warnTM"  label="时间" min-width="160">
        </el-table-column>
        <el-table-column align="center" header-align="center" prop="remark"  label="操作" min-width="180">
         <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="createFile(scope.row)" v-show="!scope.row.fileUrl">报表生成</el-button>
            <el-button type="success" size="mini" @click="exportFile(scope.row)" v-show="scope.row.fileUrl">导出</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import * as L from 'leaflet'
import screenfull from 'screenfull'
import monitorTypes from '@/store/types/monitor'
import scenceTypes from '@/store/types/scence'
import meiyuTypes from '@/store/types/meiyu'
import warnTypes from '@/store/types/warningcenter'
import stationDialog from '@/components/stationDialog'
import { setMapMarkerItem6, selectMapLayer1 } from '@/utils/map'
import config from '@/config'
import request from '@/utils/request'
// import { selectMapLayer1 } from '@/utils/map'
import riskchartTypes from '@/store/types/riskchart'
require('@/extend/leaflet-extend.js')
require('@/assets/map/leaflet.ChineseTmsProviders.js')
var echarts = require('echarts')
export default {
  name: 'meiyu',
  components: { stationDialog },
  data() {
    return {
      yjcData: {},
      dialogYjc: false,
      waterRainTableData: [],
      dialogWaterRainInfo: false,
      waterRainloading: false,
      waterRainHeight: 10,
      warnTMMin: '',
      warnTMMax: '',
      picicon: true,
      picControl: false,
      BeginTime: '',
      EndTime: '',
      onTheHourRainTime: '1',
      radioList2: [
        { name: '1小时', label: '1' },
        { name: '3小时', label: '3' },
        { name: '24小时', label: '24' },
        { name: '48小时', label: '48' },
        { name: '72小时', label: '72' }
      ],
      timeChoose: false,
      activeName: '1',
      stActiveName: '1',
      showViewer: false,
      showRadioDiv: false,
      stMarkerPopup: false,
      markerPopup: false,
      enterList: true,
      commontableh: '50',
      commonrestableh: '50',
      hiddenTableHeader: false,
      staname: '',
      waterstaname: '',
      backitem: true,
      watchfull: '',
      choset: false,
      isFullscreen: false,
      myChartHeight: '',
      dialogFormVisible: false,
      datev: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      allrain: '',
      watername: '',
      aDDVCD: '330324',
      documentwidth: document.documentElement.clientWidth,
      meiyurain: [],
      tops: [],
      alldz: [],
      loading: true,
      loading1: true,
      loadingd: true,
      loadingRes: false,
      date: '',
      height: document.documentElement.clientHeight + 'px',
      tableheight: 50,
      rtableheight: 50,
      superpolice: [],
      gates: [],
      riverData: [],
      overriverData: [],
      commonriverData: [],
      reservoirData: [],
      overresData: [],
      commonresData: [],
      selectedTime: [
        {
          name: '24h',
          value: '24h',
          num: 24
        },
        {
          name: '3h',
          value: '3h',
          num: 3
        },
        {
          name: '1h',
          value: '1h',
          num: 1
        },
        {
          name: '自定义',
          value: 'customize',
          num: 0
        }
      ],
      selectedTimeDialog: [ // 不包含自定义时间
        {
          name: '24h',
          value: '24h',
          num: 24
        },
        {
          name: '3h',
          value: '3h',
          num: 3
        },
        {
          name: '1h',
          value: '1h',
          num: 1
        }
      ],
      selectedReservoirRiver: [
        {
          name: '水库',
          value: 'reservoir'
        },
        {
          name: '河道',
          value: 'river'
        }
      ],
      choosed: 2,
      choosed2: 2,
      choosed3: 2,
      chooseItem: '',
      chartnameAll: [],
      topsixvalueAll: [],
      choosed1: 0,
      gataData: [],
      minwidth: '75',
      moregate: [],
      yj: [
        { name: '预警村落', num: 0, iconUrl: require('@/assets/meiyu/yjcl.png') },
        { name: '水库超汛限', num: 0, iconUrl: require('@/assets/meiyu/skcxx.png') },
        { name: '河道水位超警', num: 0, iconUrl: require('@/assets/meiyu/swcj.png') },
        { name: '雨量1h>30', num: 0, iconUrl: require('@/assets/meiyu/ylcj.png') },
        { name: '雨量3h>60', num: 0, iconUrl: require('@/assets/meiyu/ylcj.png') },
        { name: '雨量6h>80', num: 0, iconUrl: require('@/assets/meiyu/ylcj.png') }
      ],
      villageOver: [],
      reservoirOver: [],
      riverOver: [],
      rain1hOver: [],
      rain3hOver: [],
      rain6hOver: [],
      sID: '22',
      sTID: '214',
      stationType: '2',
      waterFactor: '',
      rivercoordinate: [],
      map: '',
      dialogVisible: false,
      dialogLoading: false,
      therainchart: false,
      BeginTimemy: '2019-06-01',
      tabName: '河道',
      statable: [],
      rainMarkers: null,
      riverMarkers: [],
      minWarning: 0,
      minGuarantee: 0,
      navli: [
        { id: 1, name: '现场图片', img: require('@/assets/riskchart/xctp.png'), select: true, isShow: false },
        { id: 2, name: '雨量站', img: require('@/assets/riskchart/ylz.png'), select: false, isShow: true },
        { id: 3, name: '河道站', img: require('@/assets/riskchart/swz.png'), select: false, isShow: true },
        { id: 4, name: '重要村落', img: require('@/assets/riskchart/zycl.png'), select: true, isShow: true },
        { id: 5, name: '危险区', img: require('@/assets/riskchart/wxq.png'), select: false, isShow: true },
        { id: 6, name: '山塘', img: require('@/assets/riskchart/st.png'), select: false, isShow: false },
        { id: 7, name: '水库站', img: require('@/assets/riskchart/sk.png'), select: false, isShow: true }
      ],
      searchList: [
        {
          value: 0,
          adnm: '村落',
          children: []
        }
      ],
      pointIndex: 0, // 当前锚点index
      czpointIndex: 0, // 当前测站锚点index
      stpointIndex: 0, // 当前测站锚点index
      ylzMarkers: null, // 雨量站
      hdzMarkers: null, // 河道站
      skzMarkers: null, // 水库站
      wxqMarkers: null, // 危险区
      zyclMarkers: null, // 重要村落
      xctpMarkers: null, // 现场图片
      stMarkers: null, // 山塘
      ljzyMarkers: null, // 立即转移
      zbzyMarkers: null, // 准备转移
      sxMarkers: null, // 水系,
      yjTipShow: false,
      yjVillage: { moving: [], readyForMoving: [] },
      wxqPointData: [{ pic: { picUrl: [] }, danger: {} }],
      stPointData: [{}],
      wxqData: [],
      zyclData: [],
      fydxData: [],
      czData: [ ],
      popupTableH: 180,
      yjzbData: [], // 预警指标
      yjryData: [], // 预警人员
      isShowToolip: false,
      hoverCurrentStcd: ''
    }
  },
  methods: {
    // 未超警
    handleMouseEnter(row, column, cell, event) {
      this.enterList = false
      this.hoverCurrentStcd = row.stcd // 显示当前stcd站点
    },
    handleMouseOut(row, column, cell, event) {
      this.enterList = true
      this.hoverCurrentStcd = ''
    },
    // 超警
    handleOverMouseEnter(row, column, cell, event) {
      this.hoverCurrentStcd = row.stcd // 显示当前stcd站点
    },
    handleOverMouseOut(row, column, cell, event) {
      this.hoverCurrentStcd = ''
    },
    showWaterRainDialog() {
      this.dialogWaterRainInfo = true
      this.getWaterRainInfoData()
      this.$nextTick(() => {
        let contentDiv = document.getElementsByClassName('el-dialog__body')
        if (window.screen.width <= 1366) {
          this.waterRainHeight = contentDiv[0].offsetHeight - 30 + 'px'
        } else {
          this.waterRainHeight = contentDiv[0].offsetHeight - 50 + 'px'
        }
      })
    },
    // 设置默认起止时间
    setDefaultTime () {
      var date = new Date()
      var warnTMMinMs = date.getTime() - 1 * 3600 * 1000 * 24
      var minDate = new Date(warnTMMinMs)
      this.warnTMMax = this.$moment(date).format('YYYY-MM-DD HH:mm')
      this.warnTMMin = this.$moment(minDate).format('YYYY-MM-DD HH:mm')
    },
    // 获取数据
    getWaterRainInfoData () {
      this.waterRainloading = true
      this.$store.dispatch(warnTypes.GET_WARNRECORD_LIST, {
        warnTM_Min: this.warnTMMin,
        warnTM_Max: this.warnTMMax,
        pageIndex: 1,
        pageSize: 9999
      }).then(data => {
        this.waterRainTableData = data.results
        this.waterRainloading = false
      })
    },
    createFile(row) {
      this.waterRainloading = true
      this.$store.dispatch(meiyuTypes.SAVE_ONE_RAIN_WATER_NOTICE, {
        time: row.warnTM
      }).then(data => {
        this.getWaterRainInfoData()
        this.$message({
          message: '报表生成成功',
          type: 'success'
        })
        this.waterRainloading = false
      })
    },
    exportFile(row) {
      window.open(`${config.ApiYJ}${row.fileUrl}`)
    },
    showcontral() {
      this.picControl = true
      this.picicon = false
    },
    timeselect() {
      this.timeChoose = false
      this.rainChange()
    },
    customTimeChange(e, label) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理
      // this.hour2 = label
      this.BeginTime = this.getCurrentTime(label)
      this.EndTime = this.getCurrentTime(0)
      // console.log(777, this.BeginTime)
      this.rainChange()
      this.timeChoose = false
    },
    handleClick() {},
    togglewater() {
      if (this.choosed1 === 1) {
        this.riverwater()
      } else {
        this.reservoirwater()
      }
    },
    // 列排序
    sortChange1(a, b) {
      return Number(a.overflowWarningWater_Str) - Number(b.overflowWarningWater_Str)
    },
    sortChange2(a, b) {
      return Number(a.overflowGuaranteeWater_Str) - Number(b.overflowGuaranteeWater_Str)
    },
    sortMethod1(a, b) {
      let bsort = b.overflowWarningWater_Str === undefined ? this.minWarning - 1 : Number(b.overflowWarningWater_Str)
      let asort = a.overflowWarningWater_Str === undefined ? this.minWarning - 1 : Number(a.overflowWarningWater_Str)
      return bsort - asort
    },
    sortMethod2(a, b) {
      let bsort = b.overflowGuaranteeWater_Str === undefined ? this.minGuarantee - 1 : Number(b.overflowGuaranteeWater_Str)
      let asort = a.overflowGuaranteeWater_Str === undefined ? this.mminGuarantee - 1 : Number(a.overflowGuaranteeWater_Str)
      return bsort - asort
    },
    choosetime() {
      this.choset = true
    },
    buttonfull() {
      if (!screenfull.enabled) {
        return false
      } else {
        screenfull.toggle()
      }
    },
    meiyu() {
      this.meiyurain = []
      this.BeginTimemy = this.datev
      this.seasonRainfall()
    },
    back() {
      this.isFullscreen = true
      this.$nextTick(() => {
        this.$router.push({ name: 'Homepage' })
      })
    },
    drawChart(chartname, topsixvalue) {
      let maxRain = Math.max(...topsixvalue) // 乡镇面雨量最大值
      if (maxRain > 10) {
        maxRain = maxRain + 5
      } else {
        maxRain = 10
      }
      let myChart = this.$echarts.init(document.getElementById('rainchart'))
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          text: '乡镇面雨量Top3',
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '-4%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: chartname,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function() {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            max: Math.ceil(maxRain) // 最大值
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: topsixvalue,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    drawChartAll(chartnameAll, topsixvalueAll) {
      let maxRain = Math.max(...topsixvalueAll) // 全县面雨量最大值
      if (maxRain > 10) {
        maxRain = maxRain + 5
      } else {
        maxRain = 10
      }
      let rainchartAll = this.$refs.rainchartAll
      let myChart = this.$echarts.init(rainchartAll)
      myChart.clear()
      myChart.setOption({
        title: {
          top: 5,
          textStyle: {
            // 文字颜色
            color: '#fff',
            // 字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            // 字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            // 字体系列
            fontFamily: 'sans-serif',
            // 字体大小
            fontSize: 13
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '5%',
          top: '30%',
          containLabel: true
        },
        tooltip: {},
        xAxis: [
          {
            type: 'category',
            data: chartnameAll,
            axisTick: {
              // alignWithLabel: true,
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              interval: 0,
              // rotate: 15,
              // 强制文字产生间隔
              textStyle: {
                // 文字样式
                color: '#fff',
                fontSize: 12,
                fontFamily: 'Microsoft YaHei'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#02cae5'
              }
            },
            axisLabel: {
              formatter: function() {
                return ''
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            max: Math.ceil(maxRain) // 最大值
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            barWidth: '40%',
            data: topsixvalueAll,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  1,
                  0,
                  0,
                  [
                    {
                      offset: 0,
                      color: '#00a2ff' // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: '#01bbef' // 60% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#02cae5' // 100% 处的颜色
                    }
                  ],
                  false
                ),
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    // 数值样式
                    color: '#02cae5',
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      })
    },
    tableRowClassName({ row, rowIndex }) {
      let over = row.overflowGuaranteeWater_Str
      if (over === undefined) {
        over = -9999
      } else {
        over = parseFloat(over)
      }
      if (row.overflowWarningWater > 0 && over <= 0) {
        // 超警戒未超保证
        return 'warning-row'
      } else if (over > 0) {
        return 'success-row'
      }
      return ''
    },
    tableRowClassName1({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        // 超汛限
        return 'success-row'
      }
      return ''
    },
    getnowtime() {
      let thedate = new Date()
      let year = thedate.getFullYear()
      let month = thedate.getMonth() + 1
      let date = thedate.getDate()
      let hours = thedate.getHours()
      let minutes = thedate.getMinutes()
      let seconds = thedate.getSeconds()
      let weekend = thedate.getDay()
      switch (weekend) {
        case 1:
          weekend = '星期一'
          break
        case 2:
          weekend = '星期二'
          break
        case 3:
          weekend = '星期三'
          break
        case 4:
          weekend = '星期四'
          break
        case 5:
          weekend = '星期五'
          break
        case 6:
          weekend = '星期六'
          break
        case 0:
          weekend = '星期日'
          break
      }
      this.date = year + '年' + this.conver(month) + '月' + this.conver(date) + '日' + ' ' + weekend + ' ' + this.conver(hours) + ':' + this.conver(minutes) + ':' + this.conver(seconds)
    },
    conver(s) {
      return s < 10 ? '0' + s : s
    },
    leaflet(arr) {
      let map = ''
      map = L.CreateTianDiTuMap('centermap', {
        mapType: 3,
        crs: L.CRS.EPSG4490,
        zoomControl: false,
        minZoom: 10, // 最小缩放等级
        maxZoom: 18
      }).setView([28.33, 120.68], 11)
      // L.tileLayer.CustomArcGISServerLayer(
      //   config.ApiYJ + '/assets/images/town/' // 地图服务地址
      // ).addTo(map)
      var myStyle = {
        color: '#2dd9f8',
        weight: 3,
        opacity: 1
      }
      request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then((res) => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
        // this.drawBoundary(res.data.features[0].geometry.coordinates[0], map)
      })
      this.map = map
    },
    // 实时雨情点击切换
    checkItem(item, index) {
      if (item.name === '自定义') {
        this.timeChoose = true
      }
      this.choosed = index
      this.chooseItem = item
      this.rainChange()
      if (this.rainMarkers) {
        this.rainMarkers.clearLayers()
        this.rainMarkers = null
      }
      this.drawRainPoints()
    },
    // 实时雨情-全县面雨量点击切换
    checkItem2(item, index) {
      this.choosed2 = index
      // this.commonRaininfo('qqmyl', item)
      this.dialogLoading = true
      this.commonRainChartInfo('qqmyl', item)
    },
    openAllrainDialog() {
      this.dialogVisible = true
      this.checkItem2(this.chooseItem, this.choosed)
    },
    // 实时雨情点击切换
    rainChange() {
      this.loading1 = true
      this.$store
        .dispatch(meiyuTypes.GET_ANALYTICAL_RAIN, {
          // addvcd: this.aDDVCD,
          stationName: this.staname,
          mainStation: true,
          // beginTime: this.datev,
          type: this.chooseItem.value,
          beginTime: this.BeginTime,
          endTime: this.EndTime
        })
        .then((data) => {
          this.allrain = data.avgRain
          this.tydate = data.townRain
          // top3测站排序
          const handleSort = (prop) => {
            return function(a, b) {
              const val1 = a[prop]
              const val2 = b[prop]
              return val2 - val1
            }
          }
          this.tydate = this.tydate.sort(handleSort('value')) // 排序后top3
          let chartname = []
          let topsixvalue = []
          this.tydate.slice(0, 3).forEach((item) => {
            chartname.push(item.name)
            topsixvalue.push(item.value)
          })
          this.drawChart(chartname, topsixvalue)
          let sortlist = data.stationRain
          this.statable = sortlist.sort((a, b) => {
            let bsort = b.value === null ? -1 : b.value
            let asort = a.value === null ? -1 : a.value
            return bsort - asort
          })
          this.loading1 = false
        })
    },
    // 雨量站打点
    drawRainPoints() {
      let layers = []
      this.$store
        .dispatch(monitorTypes.GET_STATISTICS_RAIN, {
          sID: this.sID,
          appType: '1',
          beginTime: this.getCurrentTime(this.selectedTime[this.choosed].num),
          endTime: this.getCurrentTime(0),
          mainStation: true,
          showFreq: true
        })
        .then((data) => {
          data.rows.forEach((item, index) => {
            var myIcon1 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_0.png'),
              iconAnchor: [8, 8]
            })
            var myIcon2 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_1.png'),
              iconAnchor: [8, 8]
            })
            var myIcon3 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_2.png'),
              iconAnchor: [8, 8]
            })
            var myIcon4 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_3.png'),
              iconAnchor: [8, 8]
            })
            var myIcon5 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_4.png'),
              iconAnchor: [8, 8]
            })
            var myIcon6 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_5.png'),
              iconAnchor: [8, 8]
            })
            var myIcon7 = L.icon({
              iconUrl: require('@/assets/meiyu/yl_6.png'),
              iconAnchor: [8, 8]
            })
            var myIcon = myIcon1
            if (item.accRain === 0) {
              myIcon = myIcon1
            } else if (item.accRain > 0 && item.accRain < 10) {
              myIcon = myIcon2
            } else if (item.accRain >= 10 && item.accRain < 25) {
              myIcon = myIcon3
            } else if (item.accRain >= 25 && item.accRain < 50) {
              myIcon = myIcon4
            } else if (item.accRain >= 50 && item.accRain < 100) {
              myIcon = myIcon5
            } else if (item.accRain >= 100 && item.accRain < 250) {
              myIcon = myIcon6
            } else if (item.accRain >= 250) {
              myIcon = myIcon7
            }
            let waterData = null
            if (item.sttp.includes('ZZ')) {
              waterData = this.riverData.find((el) => {
                return el.stcd === item.stcd
              })
            } else if (item.sttp.includes('RR')) {
              waterData = this.reservoirData.find((el) => {
                return el.stcd === item.stcd
              })
            }
            let html = `<b>${item.stnm}</b> 雨量:${item.accRain ? item.accRain : '--'}mm`
            if (waterData && waterData.water) {
              html = `<b>${item.stnm}</b> 雨量:${item.accRain ? item.accRain : '--'}mm 水位:${waterData.water.toFixed(2)}m`
            }
            let markers = L.marker([item.lttd, item.lgtd], { icon: myIcon })
            markers.metadata = { stid: item.id, lat: item.lttd, lng: item.lgtd }
            markers.bindTooltip(html, {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
            markers.on('click', () => {
              this.$refs.stationDialog.showlog(item)
            })
            layers.push(markers)
          })
          if (layers.length > 0) {
            this.rainMarkers = L.layerGroup(layers)
            this.map.addLayer(this.rainMarkers)
          }
          this.loading = false
        })
    },
    // 全区面雨量弹窗
    commonRainChartInfo(type, item) {
      this.$store
        .dispatch(meiyuTypes.GET_ANALYTICAL_RAIN, {
          aDDVCD: this.aDDVCD,
          beginTime: '',
          type: item.value
        })
        .then((data) => {
          if (type === 'qqmyl') {
            let chartData = data.townRain
            // top3测站排序
            const handleSort = (prop) => {
              return function(a, b) {
                const val1 = a[prop]
                const val2 = b[prop]
                return val2 - val1
              }
            }
            chartData = chartData.sort(handleSort('value')) // 排序后全县面雨量
            let chartname = []
            let topsixvalue = []
            chartData.forEach((item) => {
              let reg1 = new RegExp('镇', 'g')// g代表全部
              let reg2 = new RegExp('乡', 'g')// g代表全部
              let reg3 = new RegExp('县', 'g')// g代表全部
              let reg4 = new RegExp('街道', 'g')// g代表全部
              item.name = item.name.replace(reg1, '').replace(reg2, '').replace(reg3, '').replace(reg4, '')
              chartname.push(item.name)
              topsixvalue.push(item.value)
            })
            this.drawChartAll(chartname, topsixvalue)
            this.dialogLoading = false
          } else {
            this.alldz = data.stationRain
            // this.dialogStationLoading = false
          }
          this.alldz = data.stationRain
          this.loading = false
        })
    },
    // 公共雨情信息接口调用
    commonRaininfo(type, item) {
      this.$store
        .dispatch(meiyuTypes.GET_TOWN_RAIN, {
          sid: this.sID,
          aDDVCD: this.aDDVCD,
          type: item.value,
          townOrderField: 'Rain',
          mainStation: true,
          stationOrderField: ''
        })
        .then((data) => {
          let detailarr = data.townData
          let chartnameAll = []
          let topsixvalueAll = []
          detailarr.forEach((item) => {
            chartnameAll.push(item.addvcd)
            topsixvalueAll.push(item.rain)
          })
          if (type === 'qqmyl') {
            this.drawChartAll(chartnameAll, topsixvalueAll)
          } else {
            this.chartnameAll = chartnameAll
            this.topsixvalueAll = topsixvalueAll
          }
          this.alldz = data.stationData
          this.loading = false
        })
    },
    // 实时水情点击切换
    checkItem1(item, index) {
      this.choosed1 = index
      let _this = this
      // this.$nextTick(() => {
      //   let contentDiv = document.getElementsByClassName('right')
      //   let overresDiv = document.getElementsByClassName('overrestable')
      //   if (window.screen.width <= 1366) {
      //     _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 105 + 'px'
      //   } else {
      //     _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 75 + 'px'
      //   }
      // })
      let contentDiv = document.getElementsByClassName('right')
      let overDiv = document.getElementsByClassName('overtable')
      let overresDiv = document.getElementsByClassName('overrestable')
      if (window.screen.width <= 1366) {
        _this.commontableh = contentDiv[0].offsetHeight - overDiv[0].offsetHeight - 170 + 'px'
        _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 200 + 'px'
      } else {
        _this.commontableh = contentDiv[0].offsetHeight - overDiv[0].offsetHeight - 250 + 'px'
        _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 380 + 'px'
      }
    },
    // 河道水情
    async riverwater() {
      this.loading = true
      let res = await this.$store.dispatch(monitorTypes.GET_STATISTICS_RIVER_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: this.waterstaname,
        orderField: 'overflowWarningWater',
        mainStation: true,
        desc: true
      })
      this.riverData = res.rows
      let arr = res.rows
      if (arr) {
        this.overriverData = []
        this.commonriverData = []
        arr.forEach((el) => {
          if (el.overflowWarningWater > 0) {
            this.overriverData.push(el)
          } else {
            this.commonriverData.push(el)
          }
        })
      }
      // 河道水位超警戒排序,获取最小值
      let filterWaterData = this.riverData.filter((item) => {
        // 过滤数组中undefined类型
        return item.overflowWarningWater !== undefined
      })
      let min = Math.min.apply(
        Math,
        filterWaterData.map((item) => {
          return item.overflowWarningWater
        })
      )
      this.minWarning = min
      // 河道水位超保证排序,获取最小值
      let filterGuaranteeWaterData = this.riverData.filter((item) => {
        // 过滤数组中undefined类型
        return item.overflowGuaranteeWater !== undefined
      })
      let min1 = Math.min.apply(
        Math,
        filterGuaranteeWaterData.map((item) => {
          return item.overflowGuaranteeWater
        })
      )
      this.minGuarantee = min1
      this.loading = false
      this.drawRiverPoints(res.rows)
    },
    // 河道站打点
    drawRiverPoints(data) {
      data.forEach((item) => {
        if (item.sttp === 'ZZ') {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/water.gif'),
            shadowUrl: require('@/assets/meiyu/water.gif'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
          markers.metadata = { stid: item.id, lat: item.lttd, lng: item.lgtd }
          markers.bindTooltip('<b>' + item.stnm + '</b>', {
            parmanent: true,
            sticky: true,
            className: 'anim-tooltip'
          })
          markers.on('click', () => {
            this.$refs.stationDialog.showlog(item)
          })
        }
      })
    },
    // 水库水情
    async reservoirwater() {
      this.loading = true
      let res = await this.$store.dispatch(monitorTypes.GET_STATISTICS_RESERVOIR_WATER, {
        aDDVCD: this.aDDVCD,
        stationName: this.waterstaname,
        mainStation: true,
        orderField: 'overflowWarningWater',
        desc: true
      })
      let temp = res.rows
      temp.sort((a, b) => {
        let bsort = b.overflowWarningWater === undefined ? -89999 : b.overflowWarningWater
        let asort = a.overflowWarningWater === undefined ? -89999 : a.overflowWarningWater
        return bsort - asort
      })
      let arr = temp
      if (arr) {
        this.overresData = []
        this.commonresData = []
        arr.forEach((el) => {
          if (el.overflowWarningWater > 0) {
            this.overresData.push(el)
          } else {
            this.commonresData.push(el)
          }
        })
      }
      this.reservoirData = temp
      // 河道水位超汛限排序,获取最小值
      let filterWaterData = this.reservoirData.filter((item) => {
        // 过滤数组中undefined类型
        return item.overflowWarningWater !== undefined
      })
      let min = Math.min.apply(
        Math,
        filterWaterData.map((item) => {
          return item.overflowWarningWater
        })
      )
      this.minWarning = min
      this.loading = false
      this.drawReservoirPoints(res.rows)
    },
    // 水库打点
    drawReservoirPoints(data) {
      let reservior = L.icon({
        iconUrl: require('@/assets/homepage_img/reservior-icon.png'),
        shadowUrl: require('@/assets/homepage_img/reservior-icon.png'),
        iconSize: [15, 15],
        shadowSize: [15, 15]
      })
      data.forEach((item) => {
        if (item.sttp === 'RR') {
          let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
          if (item.diff >= 0) {
            markers.bindTooltip('<span>' + item.stnm + ':' + item.water + 'm 超限:<span style="color:red;">' + item.diff + '</span>m</span>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
          } else {
            markers.bindTooltip('<b>' + item.stnm + '</b>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
          }
          markers.metadata = { stid: item.stid, lat: item.lttd, lng: item.lgtd }
          markers.on('click', () => {
            this.$refs.stationDialog.showlog(item)
          })
        }
      })
    },
    rainoverflow() {
      this.$store.dispatch(meiyuTypes.GET_WATER_OVERFLOW, { sID: this.sID, mainStation: true }).then((data) => {
        this.yj[3].num = data.total1
        this.yj[4].num = data.total3
        this.yj[5].num = data.total6
        data.rowsOf1h.forEach((item) => {
          this.rain1hOver.push(`<span>${item.stnm}</span>雨量:${item.rainNow}mm 1小时雨量:<span class='red'>${item.rain1}</span>mm`)
        })
        if (this.rain1hOver.length === 0) {
          this.rain1hOver.push('暂无超警')
        }
        data.rowsOf3h.forEach((item) => {
          this.rain3hOver.push(`<span>${item.stnm}</span>雨量:${item.rainNow}mm 3小时雨量:<span class='red'>${item.rain3}</span>mm`)
        })
        if (this.rain3hOver.length === 0) {
          this.rain3hOver.push('暂无超警')
        }
        data.rowsOf6h.forEach((item) => {
          this.rain6hOver.push(`<span>${item.stnm}</span>雨量:${item.rainNow}mm 6小时雨量:<span class='red'>${item.rain6}</span>mm`)
        })
        if (this.rain6hOver.length === 0) {
          this.rain6hOver.push('暂无超警')
        }
        if (data.total1 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf1h
          coordinates.forEach((item) => {
            let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
            markers.bindTooltip('<b>' + item.stnm + '</b>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
            markers.on('click', () => {
              this.$refs.stationDialog.showlog(item)
            })
          })
        }
        if (data.total3 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf3h
          coordinates.forEach((item) => {
            let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
            markers.bindTooltip('<b>' + item.stnm + '</b>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
            markers.on('click', () => {
              this.$refs.stationDialog.showlog(item)
            })
          })
        }
        if (data.total6 > 0) {
          let reservior = L.icon({
            iconUrl: require('@/assets/meiyu/ylcj.png'),
            shadowUrl: require('@/assets/meiyu/ylcj.png'),
            iconSize: [25, 25],
            shadowSize: [25, 25]
          })
          let coordinates = data.rowsOf6h
          coordinates.forEach((item) => {
            let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
            markers.bindTooltip('<b>' + item.stnm + '</b>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
            markers.on('click', () => {
              this.$refs.stationDialog.showlog(item)
            })
          })
        }
      })
    },
    resoverflow(type) {
      this.$store.dispatch(meiyuTypes.GET_RES_OVERFLOW, { stationType: type, sID: this.sID, mainStation: true }).then((data) => {
        if (type === 1) {
          this.yj[2].num = data.riverWarningTotal
          data.rows.forEach((item) => {
            this.riverOver.push(`<span>${item.stnm}</span>水位:${item.water}m 警戒水位:${item.wrz}m 超警戒水位:<span class='red'>${this.global.formatNumber(item.water - item.wrz, 2)}</span>m`)
          })
          if (this.riverOver.length === 0) {
            this.riverOver.push('暂无超警')
          }
          if (data.riverWarningTotal > 0) {
            var river = L.icon({
              iconUrl: require('@/assets/meiyu/swcj.png'),
              shadowUrl: require('@/assets/meiyu/swcj.png'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            let coordinates = data.rows
            coordinates.forEach((item) => {
              var markers = L.marker([item.lttd, item.lgtd], { icon: river }).addTo(this.map)
              markers.bindTooltip('<b>' + item.stnm + '</b>', {
                parmanent: true,
                sticky: true,
                className: 'anim-tooltip'
              })
              markers.on('click', () => {
                this.$refs.stationDialog.showlog(item)
              })
            })
          }
        } else {
          this.yj[1].num = data.reservoirTotal
          data.rows.forEach((item) => {
            this.reservoirOver.push(`<span>${item.stnm}</span>水位:${item.water}m 汛限水位:${item.wrz}m 超汛限水位:<span class='red'>${this.global.formatNumber(item.water - item.wrz, 2)}</span>m`)
          })
          if (this.reservoirOver.length === 0) {
            this.reservoirOver.push('暂无超警')
          }
          if (data.reservoirTotal > 0) {
            var reservior = L.icon({
              iconUrl: require('@/assets/meiyu/skcxx.png'),
              shadowUrl: require('@/assets/meiyu/skcxx.png'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            let coordinates = data.rows
            coordinates.forEach((item) => {
              var markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
              markers.bindTooltip('<b>' + item.stnm + '</b>', {
                parmanent: true,
                sticky: true,
                className: 'anim-tooltip'
              })
              markers.on('click', () => {
                this.$refs.stationDialog.showlog(item)
              })
            })
          }
        }
      })
    },
    warnvillage() {
      this.$store.dispatch(warnTypes.GET_WARNRECORD_LIST, { IsExistence: true, isVillage: true, pageIndex: '1', pageSize: '500' }).then((data) => {
        this.yj[0].num = data.total
        data.results.forEach((item) => {
          this.villageOver.push(item.adnm)
        })
        if (this.villageOver.length === 0) {
          this.villageOver.push('暂无超警')
        }
        if (data.total > 0) {
          let coordinates = data.results
          coordinates.forEach((item) => {
            let reservior = L.icon({
              iconUrl: require('@/assets/meiyu/yjcl.gif'),
              iconSize: [25, 25],
              shadowSize: [25, 25]
            })
            if (item.warnGradeID === '4') {
              reservior = L.icon({
                iconUrl: require('@/assets/meiyu/yjcl_orange.gif'),
                iconSize: [25, 25],
                shadowSize: [25, 25]
              })
            }
            let markers = L.marker([item.lttd, item.lgtd], { icon: reservior }).addTo(this.map)
            markers.bindTooltip('<b>' + item.warnNM + '</b>', {
              parmanent: true,
              sticky: true,
              className: 'anim-tooltip'
            })
            markers.on('click', () => {
              this.yjcData = item
              this.dialogYjc = true
            })
          })
        }
      })
    },
    seasonRainfall() {
      this.loadingd = true
      this.$store.dispatch(meiyuTypes.GET_RAINLY_SEASON_RAINFALL, { aDDVCD: this.aDDVCD, beginTime: this.BeginTimemy }).then((data) => {
        this.meiyurain.push({ name: '梅雨期面雨量', value: data.data.rain })
        this.meiyurain.push({ name: '常年同期', value: data.data.lastYearRian })
        this.meiyurain.push({ name: '同比', value: data.data.accRate })
        this.loadingd = false
      })
    },
    // 河道/水库水情行选中定位坐标
    handleRowClick(item) {
      selectMapLayer1(this, item, this.map)
    },
    getCurrentTime(hour) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 60 * 60 * 1000 * Number(hour))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      // let mm = nowdate.getMinutes()
      let time = year + '-' + (mon > 9 ? mon : '0' + mon) + '-' + (dd > 9 ? dd : '0' + dd) + ' ' + (hh > 9 ? hh : '0' + hh) + ':00'
      return time
    },
    // 列表滚动方法
    scrolltable(val) {
      let that = this
      // let refs = that.$refs
      // const table = refs[val]
      let table = that.$refs[val]
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper || ''
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每200毫秒移动1像素)
      // 元素自增距离顶部1像素
      if (this.enterList) {
        divData.scrollTop += 1.5
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop === divData.scrollHeight) {
          // 重置table距离顶部距离
          divData.scrollTop = 0
        }
      }
    },
    switchChange(item, val) {
      switch (item.name) {
        case '雨量站':
          if (val === true) {
            this.getRelationInfo(['PP'], '雨量站')
          } else {
            this.getRelationInfo([], '雨量站')
          }
          break
        case '河道站':
          if (val === true) {
            this.getRelationInfo(['ZZ'], '河道站')
          } else {
            this.getRelationInfo([], '河道站')
          }
          break
        case '水库站':
          if (this.skzMarkers) {
            this.skzMarkers.clearLayers()
            this.skzMarkers = null
          }
          if (val === true) {
            this.getRelationInfo(['RR'], '水库站')
          } else {
            this.getRelationInfo([], '水库站')
          }
          break
        case '危险区':
          if (this.wxqMarkers) {
            this.wxqMarkers.clearLayers()
            this.wxqMarkers = null
          }
          if (val === true) {
            this.getPreventionDataInfo(2)
          }
          break
        case '重要村落':
          if (this.zyclMarkers) {
            this.zyclMarkers.clearLayers()
            this.zyclMarkers = null
          }
          if (val === true) {
            this.getPreventionDataInfo(1)
          }
          break
        case '山塘':
          if (this.stMarkers) {
            this.stMarkers.clearLayers()
            this.stMarkers = null
          }
          if (val === true) {
            this.getPreventionDataInfopool()
          }
          break
        // case '水系':
        //   if (val === true) {
        //     this.sxMarkers.setUrl(config.ApiYJ + '/files/layers/')
        //   } else {
        //     this.sxMarkers.setUrl('')
        //   }
        // break
        default:
          break
      }
    },
    // 村落预警信息
    async getWarnVillageByTown(data) {
      let result = await this.$store.dispatch(riskchartTypes.getWarnVillageByTown, {})
      this.yjVillage = result.detail
      this.drawVillagePoint(result.detail.readyForMovingVillage, '准备转移')
      this.drawVillagePoint(result.detail.movingVillage, '立即转移')
    },
    // 获取测站信息
    async getRelationInfo(STTPs, name) {
      let result = [[], []]
      for (let i = 0; i < STTPs.length; i++) {
        const el = STTPs[i]
        result[i] = await this.$store.dispatch(riskchartTypes.GET_relation_info, {
          STTP: el
        })
      }
      let data = []
      data = data.concat(result[0], result[1])
      if (name === '雨量站') {
        if (this.ylzMarkers) {
          this.ylzMarkers.clearLayers()
          this.ylzMarkers = null
        }
        this.getListofSearch(1, name, data)
      } else if (name === '河道站') {
        if (this.hdzMarkers) {
          this.hdzMarkers.clearLayers()
          this.hdzMarkers = null
        }
        this.getListofSearch(2, name, data)
      } else {
        if (this.skzMarkers) {
          this.skzMarkers.clearLayers()
          this.skzMarkers = null
        }
        this.getListofSearch(6, name, data)
      }
      this.czData = data
      this.drawczPoint(data, STTPs[0], name)
    },
    // 获取重要村落,危险区,现场图片信息
    async getPreventionDataInfo(flag) {
      this.loading = true
      this.fydxData = []
      let result = await this.$store.dispatch(riskchartTypes.getPreventionDataInfo, {})
      let wxq = []
      for (let i = 0; i < result.rows.length; i++) {
        const el = result.rows[i]
        if (el.lng) {
          this.fydxData.push(el)
        }
        if (el.danger) {
          wxq.push(el.danger)
          result.rows[i].adnm = result.rows[i].adnm ? result.rows[i].adnm : el.danger.adcdnm
        } else {
          wxq.push({})
        }
      }
      if (flag === 1) {
        this.drawylPoint(result.rows, '重要村落')
      } else if (flag === 2) {
        this.drawwxqPoint(wxq, '危险区')
      } else {
        this.drawylPoint(result.rows, '重要村落')
        // this.drawwxqPoint(wxq, '危险区')
      }
      this.fydxData.forEach((item, key) => {
        this.fydxData[key].value = key
      })
      this.searchList[0].children = this.fydxData
      if (result.rows.length > 0) {
        this.wxqPointData = result.rows
      }
      this.loading = false
    },
    // 获取山塘信息
    async getPreventionDataInfopool() {
      this.loading = true
      let result = await this.$store.dispatch(riskchartTypes.getPreventionDataInfopool, {})
      this.drawstPoint(result.rows, '山塘信息')
      if (result.rows.length > 0) {
        this.stPointData = result.rows
      }
      this.loading = false
    },

    // 乡镇危险区表格list
    async getDangerAreaInfotown() {
      this.loading = true
      let result = await this.$store.dispatch(riskchartTypes.getDangerAreaInfotown, {})
      this.wxqData = result.rows
      this.loading = true
    },
    // 重要村落表格list
    async getPreventionDataInfotown() {
      this.loading = true
      let result = await this.$store.dispatch(riskchartTypes.getPreventionDataInfotown, {})
      this.zyclData = result.rows
      this.loading = true
    },
    // 水雨情
    async getRainWaterTotal() {
      let result = await this.$store.dispatch(riskchartTypes.getRainWaterTotal, {
        STID: this.stid,
        BeginTime: this.beginTime,
        EndTime: this.endTime
      })
      this.dialogVisible = true
      this.$nextTick(() => {
        this.drawChart2(result.waterValues, result.rainValues, result.wrZs, result.tMs)
      })
    },
    // 下拉框数据筛选
    getListofSearch(index, name, data) {
      data.forEach((item, key) => {
        data[key].adnm = item.stnm
        data[key].value = key
        data[key].lat = item.lttd
        data[key].lng = item.lgtd
      })
      if (this.navli[index].select) {
        this.searchList.push({
          value: index,
          adnm: name,
          children: data
        })
      } else {
        for (let i = this.searchList.length - 1; i >= 0; i--) {
          if (this.searchList[i].adnm === name) {
            this.searchList.splice(i, 1)
          }
        }
      }
    },
    // 地图上添加标记点
    drawylPoint(arr, type) {
      let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (item.lat) {
          if (type === '重要村落') {
            myIcon = L.icon({
              iconUrl: require('@/assets/riskchart/zycl.png'),
              iconAnchor: [8, 8]
            })
          }
          let markers = L.marker([item.lat, item.lng], {
            icon: myIcon
            // title: item.adcdName
          })
          markers.bindPopup('<div class="marker_popup" id="marker_popup' + index + '"></div>')
          markers.metadata = { adcd: item.adcd, lng: item.lng, lat: item.lat, index: index }
          markers.on('click', (e) => {
            let riverStationPopup = this.$refs['markerPopup']
            let rainfallPopupCcontent = document.getElementById('marker_popup' + index)
            this.markerPopup = true
            this.pointIndex = index
            if (item.adnm) {
              this.activeName = '1'
            } else {
              this.activeName = '2'
            }
            rainfallPopupCcontent.appendChild(riverStationPopup)
            this.$nextTick(() => {
              let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
              pop.style.left = '-205px'
              let tabsDom = document.getElementsByClassName('el-tabs__header')[0]
              let popupTopDom = document.getElementsByClassName('popupTop')[0]
              this.popupTableH = riverStationPopup.offsetHeight - tabsDom.offsetHeight - popupTopDom.offsetHeight - 20
            })
            this.yjzbData = []
            this.yjryData = []
            this.getYjzb(item)
            this.getYjry(item)
          })
          markers.bindTooltip('<b>' + item.adnm + '</b>', {
            parmanent: true,
            sticky: true,
            className: 'anim-tooltip'
          })
          layers.push(markers)
        }
      })
      if (type === '重要村落') {
        this.zyclMarkers = L.layerGroup(layers)
        this.map.addLayer(this.zyclMarkers)
      }
    },
    // 预警指标
    getYjzb(item) {
      this.$store.dispatch(scenceTypes.GET_WARNINDEX, { villageName: item.adnm, pageIndex: 1, pageSize: 500 }).then(data => {
        this.yjzbData = data.results
      })
    },
    // 预警责任人
    getYjry(item) {
      this.$store.dispatch(warnTypes.GET_CONFIGURED_LIST, { adcdCode: item.adcd, yJLX: 'XCSYJ' }).then(data => {
        this.yjryData = data
      })
    },
    // 地图上添加标记点
    drawstPoint(arr, type) {
      let myIcon
      let layers = L.markerClusterGroup()
      arr.forEach((item, index) => {
        if (item.lat) {
          if (type === '山塘信息') {
            myIcon = L.icon({
              iconUrl: require('@/assets/riskchart/st.png'),
              iconAnchor: [8, 8]
            })
          }
          let markers = L.marker([item.lat, item.lng], {
            icon: myIcon
            // title: item.poolName
          })
          markers.bindPopup('<div class="marker_popup" id="stmarker_popup' + index + '"></div>')
          markers.on('click', (e) => {
            let riverStationPopup = this.$refs['stMarkerPopup']
            let rainfallPopupCcontent = document.getElementById('stmarker_popup' + index)
            this.stMarkerPopup = true
            this.stpointIndex = index
            rainfallPopupCcontent.appendChild(riverStationPopup)
            this.$nextTick(() => {
              let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
              pop.style.left = '-205px'
            })
            // this.$nextTick(() => {
            //   let pop = document.getElementsByClassName('leaflet-popup')
            //   pop[0].style.left = '-260px'
            //   if (pop[1]) {
            //     pop[1].style.left = '-260px'
            //   }
            // })
          })
          markers.bindTooltip('<b>' + item.poolName + '</b>', {
            parmanent: true,
            sticky: true,
            className: 'anim-tooltip'
          })
          layers.addLayer(markers)
        }
      })
      if (type === '山塘信息') {
        this.stMarkers = layers
        this.map.addLayer(this.stMarkers)
      }
    },
    // 绘制危险区面
    drawwxqPoint(arr, type) {
      // let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (item.giszb && item.giszb.length > 0) {
          let style = '#F3F34D'
          for (let i = 0; i < item.giszb.length; i++) {
            let markers = setMapMarkerItem6(this, '<b>' + item.adcdnm + '</b>', 13, item, i, style, this.map, false, false, null)
            markers.bindPopup('<div class="marker_popup" id="wxqmarker_popup' + index + 'i' + i + '"></div>')
            markers.on('click', (e) => {
              let riverStationPopup = this.$refs['markerPopup']
              let rainfallPopupCcontent = document.getElementById('wxqmarker_popup' + index + 'i' + i)
              this.markerPopup = true
              this.pointIndex = index
              if (item.adnm) {
                this.activeName = '1'
              } else {
                this.activeName = '2'
              }
              rainfallPopupCcontent.appendChild(riverStationPopup)
              this.$nextTick(() => {
                let pop = riverStationPopup.parentNode.parentNode.parentNode.parentNode
                pop.style.left = '-205px'
              })
            })
            layers.push(markers)
          }
        }
      })
      if (type === '危险区') {
        this.wxqMarkers = L.layerGroup(layers)
        this.map.addLayer(this.wxqMarkers)
      }
    },
    // 地图上添加测站标记
    drawczPoint(arr, type, name) {
      let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (type === 'PP') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/ylz.png'),
            iconAnchor: [8, 8]
          })
        } else if (type === 'ZZ') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/swz.png'),
            iconAnchor: [8, 8]
          })
        } else {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/sk.png'),
            iconAnchor: [8, 8]
          })
        }
        let markers = L.marker([item.lttd, item.lgtd], {
          icon: myIcon
        })
        markers.metadata = item
        markers.on('click', (e) => {
          this.stid = item.stid
          this.$refs.stationDialog.showlog(item)
        })
        markers.bindTooltip('<b>' + item.stnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
        layers.push(markers)
      })
      if (name === '雨量站') {
        this.ylzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.ylzMarkers)
      } else if (name === '河道站') {
        this.hdzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.hdzMarkers)
      } else {
        this.skzMarkers = L.layerGroup(layers)
        this.map.addLayer(this.skzMarkers)
      }
    },
    // 地图上添加转移村庄标记
    drawVillagePoint(arr, name) {
      let myIcon
      let layers = []
      arr.forEach((item, index) => {
        if (name === '准备转移') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/zbzy.gif'),
            iconAnchor: [8, 8]
          })
        } else if (name === '立即转移') {
          myIcon = L.icon({
            iconUrl: require('@/assets/riskchart/ljzy.gif'),
            iconAnchor: [8, 8]
          })
        }
        let markers = L.marker([item.lat, item.lng], {
          icon: myIcon
          // title: item.adnm
        })
        // markers.on('click', (e) => {
        // this.stid = item.stid
        // this.getRainWaterTotal()
        // })
        markers.bindTooltip('<b>' + item.adnm + '</b>', {
          parmanent: true,
          sticky: true,
          className: 'anim-tooltip'
        })
        layers.push(markers)
      })
      if (name === '准备转移') {
        this.zbzyMarkers = L.layerGroup(layers)
        this.map.addLayer(this.zbzyMarkers)
      } else {
        this.ljzyMarkers = L.layerGroup(layers)
        this.map.addLayer(this.ljzyMarkers)
      }
    },
    drawChart2(chartwaterValues, chartrainValues, chartwrZs, chartxline) {
      let myChart = this.$echarts.init(document.getElementById('station'))
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['雨量', '水位', '警戒水位'],
          orient: 'vertical',
          x: 'left',
          y: 'center',
          padding: [0, 30, 0, 0],
          itemWidth: 10
        },
        grid: {
          top: '10%',
          left: '10%',
          right: '4%',
          bottom: '15%'
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: false,
            data: chartxline,
            axisLabel: {
              interval: 0,
              formatter: function(params) {
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 6
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < provideNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水位',
            min: this.startWaterMark,
            scale: true,
            interval: 100,
            axisLabel: {
              formatter: '{value} m'
            }
          },
          {
            type: 'value',
            name: '雨量',
            max: function(value) {
              return Math.round(value.max * 1.5)
            },
            nameLocation: 'start',
            inverse: true, // 翻转
            interval: 30,
            axisLabel: {
              formatter: '{value} mm'
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#33C9DE'
            },
            data: chartrainValues
          },
          {
            name: '水位',
            type: 'line',
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: {
              borderWidth: 2,
              color: '#15d186'
            },
            lineStyle: {
              width: 3
            },
            data: chartwaterValues
          },
          {
            name: '警戒水位',
            type: 'line',
            symbol: 'none',
            itemStyle: {
              color: '#f4e74c'
            },
            lineStyle: {
              width: 3
            },
            data: chartwrZs
          }
        ]
      })
    }
  },
  created() {
    this.$nextTick(() => {
      this.checkItem(this.selectedTime[2], 2)
    })
  },
  async mounted() {
    this.setDefaultTime()
    this.EndTime = this.getCurrentTime(0)
    this.BeginTime = this.getCurrentTime(1)
    this.getPreventionDataInfo()
    this.getDangerAreaInfotown()
    this.getPreventionDataInfotown()
    this.getWarnVillageByTown()
    window.onresize = () => {
      this.watchfull = screenfull.isFullscreen
      if (this.watchfull) {
        this.backitem = false
      } else {
        this.backitem = true
      }
    }
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.getnowtime()
    }, 1000)
    this.rainoverflow()
    this.resoverflow(1)
    this.resoverflow(2)
    this.warnvillage()
    this.$nextTick(() => {
      this.leaflet()
    })
    this.getnowtime()
    await this.riverwater()
    await this.reservoirwater()
    this.drawRainPoints()
    this.seasonRainfall()
    this.loading = false
    this.Global.elementFix(this, this.$refs['singleStationContent'], document.getElementById('refline3'), false, (height) => {
      _this.tableheight = height
    })
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('right')
      let overDiv = document.getElementsByClassName('overtable')
      let overresDiv = document.getElementsByClassName('overrestable')
      if (window.screen.width <= 1366) {
        _this.commontableh = contentDiv[0].offsetHeight - overDiv[0].offsetHeight - 120 + 'px'
        _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 155 + 'px'
      } else {
        _this.commontableh = contentDiv[0].offsetHeight - overDiv[0].offsetHeight - 160 + 'px'
        _this.commonrestableh = contentDiv[0].offsetHeight - overresDiv[0].offsetHeight - 180 + 'px'
      }
    })
    // 列表自动滚动
    this.timer = setInterval(() => {
      // 拿到表格挂载后的真实DOM
      this.scrolltable('commontable')
      this.scrolltable('commonrestable')
      this.scrolltable('rainable')
    }, 100)
    // this.scrolltable('commontable')
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/map/leaflet.css');
@import url('./css/index.less');
/deep/ .yjdialog {
  & > .el-dialog {
    z-index: 9999999;
    margin-top: 25vh !important;
    .el-dialog__header {
      background-color: #193655;
      height: 60px;
      line-height: 60px;
      position: relative;
    }
    .el-dialog__body {
      background-color: #162942;
      padding-top: 5px;
    }
    .el-dialog__title {
      color: #c0c4cc;
      font-size: 16px;
      position: absolute;
      top: 20px;
      left: 20px;
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: 23px;
      right: 20px;
    }
    .el-icon-close:before {
      font-size: 15px;
      color: #c0c4cc;
      content: '关闭';
    }
    .el-input__inner {
      border: 1px solid #133d6a;
      background-color: #193d63;
      color: #9fb2c6;
    }
    .el-button--default {
      background-color: #184d7c;
      border: 1px solid #184d7c;
      color: #9fb2c6;
    }
    .el-table::before {
      background-color: #162942;
    }
    .is-scrolling-none {
      background-color: #162942;
    }
    .el-table th {
      background-color: #162942;
    }
  }
  .info_content {
    width: 100%;
    margin: 0 auto;
    padding: 20px 20px 0;
    margin-bottom: 7px;
    flex-wrap: wrap;
    position: relative;
    .info_text {
      box-sizing: border-box;
      margin-bottom: 15px;
      width: calc(50% - 10px);
      line-height: 20px;
      height: 40px;
      font-size: 16px;
      color: #fff;
      background: #1d2e4a;
      &:nth-of-type(1) {
        margin-right: 20px;
      }
      div {
        height: 100%;
        display: flex;
        align-items: center;
        &:nth-of-type(1) {
          background: #223c5f;
          color: #9fafbe;
          width: 120px;
          padding-right: 10px;
          justify-content: flex-end;
        }
        &:nth-of-type(2) {
          width: calc(100% - 120px);
          padding-left: 10px;
        }
      }
    }
    .info_desc {
      color: #fff;
      text-indent: 2em;
      background: #1d2e4a;
      padding: 10px;
    }
  }
}
/deep/ .waterRainInfodialog {
  & > .el-dialog {
    // z-index: 9999999;
    margin-top: 25vh !important;
    .el-dialog__header {
      background-color: #193655;
      height: 60px;
      line-height: 60px;
      position: relative;
    }
    .el-dialog__body {
      background-color: #162942;
      // padding-top: 5px;
    }
    .el-dialog__title {
      color: #c0c4cc;
      font-size: 16px;
      position: absolute;
      top: 20px;
      left: 20px;
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: 23px;
      right: 20px;
    }
    .el-icon-close:before {
      font-size: 15px;
      color: #c0c4cc;
      content: '关闭';
    }
    .el-input__inner {
      border: 1px solid #133d6a;
      background-color: #193d63;
      color: #9fb2c6;
    }
    .el-button--default {
      background-color: #184d7c;
      border: 1px solid #184d7c;
      color: #9fb2c6;
    }
    .el-table::before {
      background-color: #162942;
    }
    .is-scrolling-none {
      background-color: #162942;
    }
    .el-table th {
      background-color: #162942;
    }
  }
}
.flexDiv {
  display: flex;
  align-items: center;
}
.flexSB {
  justify-content: space-between;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 920px !important;
  height: 85px;
  left: 50%;
  margin-left: -460px;
  top: 85px;
  z-index: 9999;
}
.warnItems {
  & > div:nth-of-type(n + 2) {
    margin-top: 8px;
  }
  & > div {
    /deep/ span:nth-child(1) {
      margin-right: 8px;
    }
    /deep/ .red {
      color: red;
      font-weight: bold;
    }
  }
}
.grid-content {
  cursor: pointer;
}
.item{
  position: relative;
  .showTool {
    position: absolute;
    background:#C5B598 !important;
    color:#666;
    text-align: center;
  }
}
</style>
